// src/components/Dashboard/ProductsInTransit.js
import { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Collapse
} from '@mui/material';

function ProductsInTransit({ data }) {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleExpandClick = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index); // Aç/Kapat işlemi
  };

  return (
    <Card
      sx={{
        boxShadow: '0 4px 15px rgba(0, 0, 255, 0.2)',
        borderRadius: '12px',
        p: 2
      }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Yoldaki Ürünler
        </Typography>
        <List>
          {data.map((shipment, index) => (
            <div key={shipment.kayitNo}>
              <ListItem>
                <ListItemText
                  primary={`${shipment.gonderenAdi} - ${shipment.stokAdi}`}
                  secondary={`Kap Sayısı: ${shipment.kapSayisi}, KG: ${shipment.kg}`}
                />
                <Button
                  variant="outlined"
                  onClick={() => handleExpandClick(index)}>
                  {expandedIndex === index ? 'Detayı Kapat' : 'Detayı Gör'}
                </Button>
              </ListItem>
              <Collapse
                in={expandedIndex === index}
                timeout="auto"
                unmountOnExit>
                <CardContent>
                  <Typography variant="body2">
                    Kayıt No: {shipment.kayitNo}, Araç No: {shipment.aracNo},
                    Fiş No: {shipment.fisNo}
                  </Typography>
                  <Typography variant="body2">
                    Miktar: {shipment.miktar} {shipment.birim}, Sevk Tarihi:{' '}
                    {shipment.sevkTarihi}
                  </Typography>
                  <Typography variant="body2">Depo: {shipment.depo}</Typography>
                </CardContent>
              </Collapse>
            </div>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}

export default ProductsInTransit;
